module.exports = __webpack_public_path__ + "img/architektur-team.472891e3.png";